import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Paper } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type VAccordionProps = {
  title: string;
  content: React.ReactNode | string;
  expanded?: boolean;
};

export const VAccordion: React.FC<VAccordionProps> = ({ title, content, expanded=false }) => {
  
  const [ expan, setExpan ] = useState(false);

  const handleExpanded = () => {
    setExpan(!expan);
  };

  return (
    <Box>
      <Accordion variant='outlined' component={Paper} expanded={expanded? expanded : expan} square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} onClick={() => handleExpanded()}>
          <Typography variant="subtitle2">{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant='h6'>{content}</Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
